<template>
<div class="chapter">
<div class="inner_page">
<p class="htitle">TAKE THE FIRST SHOT</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?860775c8